import { graphic } from "echarts";

export const chartGradientColorsInspectionsSubmissionSummary = [
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "#007DF280" },
    { offset: 1, color: "#007DF226" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "#39B84580" },
    { offset: 1, color: "#39B84599" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "#FF8A00" },
    { offset: 1, color: "#FF8A00" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(176, 9, 255, 0.5)" },
    { offset: 1, color: "rgba(176, 9, 255, 0.15)" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(60, 158, 0, 0.5)" },
    { offset: 1, color: "rgba(60, 158, 0, 0.15)" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(242, 0, 174, 0.5)" },
    { offset: 1, color: "rgba(242, 0, 174, 0.15)" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(0, 184, 242, 0.5)" },
    { offset: 1, color: "rgba(0, 184, 242, 0.15)" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(255, 124, 4, 0.5)" },
    { offset: 1, color: "rgba(255, 124, 4, 0.15)" },
  ]),
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(10, 255, 167, 0.5)" },
    { offset: 1, color: "rgba(10, 255, 167, 0.15)" },
  ]),
  // Adding ten more unique gradients
  new graphic.LinearGradient(1, 0, 0, 1, [
    { offset: 0, color: "rgba(255, 0, 0, 0.5)" },
    { offset: 1, color: "rgba(255, 0, 0, 0.15)" },
  ]),
];
